import {Component, EventEmitter, Output, ViewChild} from '@angular/core';
import {ImageService} from '../../../../../../../../shared/services/advtech/image';
import {ImageSearch} from '../../../../../../services/image-search';
import {ImageShortcodeToolbarActionSheet} from '../../../../../action-sheet/image-shortcode-toolbar';
import {ImageUploadComponent} from '../../../../../image-upload';
import {ImageShortcodeBlot} from '../../../quill/blots/shortcode/image/image.shortcode.blot';
import {AbstractQuillToolbarButtonComponent} from '../abstract-quill-toolbar-button';

/**
 * Class for the ImageQuillToolbarButtonComponent
 * @class
 */
@Component({
  selector: 'advtech-image-quill-toolbar-button',
  templateUrl: './image-quill-toolbar-button.component.html',
})
export class ImageQuillToolbarButtonComponent extends AbstractQuillToolbarButtonComponent {

  /**
   * The image object
   * @type {object}
   */
  value: object;

  /**
   * URL of the image after it's been uploaded
   * @string
   */
  path: any;

  /**
   * The image form data passed from the image upload button
   * @type {any}
   */
  imageFormData: any;

  /**
   * The image upload input element
   * @type {ImageUploadComponent}
   */
  @ViewChild(ImageUploadComponent)
  imageUploadComponent: ImageUploadComponent;

  /*
  * Output for a successful upload
  * @type {EventEmitter<any>}
  */
  @Output()
  onUpload: EventEmitter<any> = new EventEmitter();

  constructor(private imageToolbarActionSheet: ImageShortcodeToolbarActionSheet,
              private imageService: ImageService,
              private imageSearch: ImageSearch) {
    super();
  }

  hClick(): any {
    const actionSheet = this.imageToolbarActionSheet.present({});
    const uploadSubscription = this.imageToolbarActionSheet.onUpload.subscribe(() => {
      this.hUpload();
    });
    const searchSubscription = this.imageToolbarActionSheet.onSearch.subscribe(() => {
      this.hSearch();
    });
    actionSheet.onDidDismiss(() => {
      uploadSubscription.unsubscribe();
      searchSubscription.unsubscribe();
    });
  }

  hUpload() {
    this.imageUploadComponent.hInputElementClick();
  }

  hSearch() {
    const imageListingModal = this.imageSearch.doImageListingModal();
    imageListingModal.onDidDismiss((data) => {
      if (data.id) {
        this.imageService.getImageData(data.id).subscribe((res) => {
          this.hImageModalDismiss(res);
        });
      }
    });
  }

  /**
   * Set the image path from the edit image modal component
   * @param {any} data The image file uploaded
   * @returns {void}
   */
  hImageModalDismiss(data) {
    if (data && data.path) {
      const quill = this.quill;
      const blot: ImageShortcodeBlot = new ImageShortcodeBlot(document.createElement('DIV'));
      const image = data.data ? data.data.images[0] : data;
      const dataset = ImageShortcodeBlot.imageToDataset(image);
      const selection = quill.getSelection(true);
      console.log(selection);
      const index = selection ? selection.index : quill.getLength();
      console.log(index);
      quill.clipboard.dangerouslyPasteHTML(index, blot.getModelTag(dataset).outerHTML);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill-toolbar/buttons/image-quill-toolbar-button/image-quill-toolbar-button.component.ts